import React, { useEffect,  useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import ColourDropDownFIlter from "../../../../components/FilterBox/ColourFilter/ColourDropDownFIlter";
import Cookies from "js-cookie";

import { format } from "date-fns";

import ColourTable from "../../../../components/Tables/ColourTable";
import ColourFilterBox from "../../../../components/FilterBox/ColourFilter/ColourFilter";
import { FiMenu } from "react-icons/fi";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import {
  ColourFilter,
  ProdGrpMCGrpCost,
  ProdGrpMCGrpCostFun,
} from "../../../../Redux/Slice/Colour/InwardAnylysis/InwardAnylysis";
import { Loader } from "../../../../components/Loader/Loader";
import Calendar from "react-calendar";
import { useTheme } from "../../../../Themecontext/Themecontext";
import ColorCalenderCss from "../../../../components/Calendar/ColorCalenderCss";

export const MachineGroupCostingAnalysis = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { ProdGrpMCGrpCostdata, ColourfilterData } = useSelector(
    (state) => state.InwardAnylysisSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICL",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  // 🔷 Dummy Data
  const productionGroupList = ColourfilterData?.ProductionGroup?.map(
    (item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    }),
  );

  const machineGroupList = ColourfilterData?.MachineGroup?.map((item) => ({
    label: item?.MachineGroupMstName,
    value: item?.MachineGroupMstID,
  }));
  const [showFilter, setShowFilter] = useState(false);

  const [selectedProduction, setSelectedProduction] = useState("");
  const [selectedProductionId, setSelectedProductionId] = useState([]);

  const [selectedMachineGroup, setSelectedMachineGroup] = useState("");
  const [selectedMachineGroupId, setSelectedMachineGroupId] = useState([]);

  const [filter, setFilter] = useState({
    productionName: [],
    machineName: [],
  });
  const [search, setSearch] = useState({
    productionName: "",
    machineName: "",
  });

  // 🔷 Date Picker
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };

  useEffect(() => {
    dispatch(ColourFilter());
    dispatch(
      ProdGrpMCGrpCost({
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
      }),
    );
  }, [dispatch, Firm, FinancialYear]);

  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type];
      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);
    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };
  const TableChartColumns = [
    {
      label: "Sr. No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Machine Group",
      key: "MachineGroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Production in Meters",
      key: "ProductionMeter",
      align: "right",
      format: "true",
    },
    {
      label: "Consumption Amount",
      key: "ConstAmt",
      align: "right",
      format: "true",
    },
    {
      label: "No. of Batches",
      key: "NoOfBatch",
      align: "right",
      format: "true",
    },
    {
      label: "Cost Per Meter",
      key: "CostPrMtr",
      align: "right",
      format: "true",
    },
  ];

  const TableChartRow = (ProdGrpMCGrpCostdata?.Detail || [])?.map((row) => ({
    MachineGroupMstName: row.MachineGroupMstName || "",
    ProductionMeter: row.ProductionMeter || "",
    ConstAmt: row.ConstAmt || "",
    NoOfBatch: row.NoOfBatch || "",
    CostPrMtr: row.CostPrMtr || "",
  }));

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!ProdGrpMCGrpCostdata || ProdGrpMCGrpCostdata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  const handlesubmit = () => {
    dispatch(ProdGrpMCGrpCostFun());
    dispatch(
      ProdGrpMCGrpCost({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
        ProductionGroupMstIDs: selectedProductionId.join(","),
        MachineGroupMstIDs: selectedMachineGroupId.join(","),
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      }),
    );


  };

  const handlesubmit1 = () => {
    dispatch(ProdGrpMCGrpCostFun());

    dispatch(
      ProdGrpMCGrpCost({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
        ProductionGroupMstIDs: filter.productionName?.join(",") || "",
        MachineGroupMstIDs: filter.machineName?.join(",") || "",
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      })
    );

    setShowFilter(false);
  };
  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        minHeight: "100vh",
        padding: "16px",
      }}
    >
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            border: "none",
          }}
        >
          <FiMenu />
        </Button>
      </div>

      <Offcanvas show={showFilter} onHide={() => setShowFilter(false)}
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        }}
      >
        <Offcanvas.Header closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
          style={{ color: isdark === "light" ? "#000" : "#FFF", }} >
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Col style={{ flex: 1 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              {/* DATE PICKER */}
              <div>
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour7,
                    padding: "13px 20px",
                    borderRadius: "12px 12px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour12,
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {" "}
                    Date Range
                  </h3>
                </div>
                <div
                  style={{
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    padding: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,
                    borderRadius: "0px 0px 12px 12px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      marginTop: "8px",
                      padding: "10px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                      borderRadius: "10px",
                      cursor: "pointer",
                      textAlign: "center",
                      color: isdark === "light" ? "#000" : "#fff",
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>
              <ColourFilterBox
                title="Production Name"
                items={productionGroupList}
                search={search.productionName}
                setSearch={(val) => handleSearch("productionName", val)}
                selectedItems={filter.productionName}
                toggleItem={(item) => toggleItem("productionName", item)}
                selectAll={() =>
                  selectAll("productionName", productionGroupList)
                }
              />
              <ColourFilterBox
                title="Machine Name"
                items={machineGroupList}
                search={search.machineName}
                setSearch={(val) => handleSearch("machineName", val)}
                selectedItems={filter.machineName}
                toggleItem={(item) => toggleItem("machineName", item)}
                selectAll={() => selectAll("machineName", machineGroupList)}
              />
              <Button
                className="mt-3 w-100"
                onClick={handlesubmit1}
                style={{
                  padding: "12px",
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour7
                      : iscolourDark?.Colour7,
                  color: "#fff",
                  width: "100%",
                  borderRadius: "12px",
                  fontWeight: "700",
                  height: "45px",
                  border: "none",
                  padding: "12px"
                }}
              >
                Apply Filters
              </Button>
            </div>
          </Col>
        </Offcanvas.Body>
      </Offcanvas>


      <div
        className="d-none d-lg-block"
        style={{
          backgroundColor:
            isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour4,
          padding: "15px",
          borderRadius: "12px",
          border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour8
            }`,
        }}
      >
        <Row className="align-items-end g-2">
          {/* DATE RANGE */}

          <Col lg={6} xl={3}>
            <div>
              <h3
                style={{
                  color: isdark === "light" ? iscolour?.Colour7 : "#fff",
                  fontWeight: "700",
                  fontSize: "13px",
                  marginBottom: "5px",
                }}
              >
                Date Range
              </h3>
            </div>
            <div>
              <div
                onClick={() => setShowDatePicker(true)}
                className="date"
                style={{
                  padding: " 12px 20px",
                  borderRadius: "16px",
                  cursor: "pointer",
                  textAlign: "center",
                  border: `1px solid ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8}`,
                  color: isdark === "light" ? iscolour?.Colour : "#fff",
                }}
              >
                {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                  : "Select Date Range"}
              </div>
            </div>
          </Col>

          {/* Production */}
          <Col lg={6} xl={3}>
            <ColourDropDownFIlter
              label="Production Name"
              data={productionGroupList}
              selectedValue={selectedProduction}
              setSelectedValue={setSelectedProduction}
              selectedId={selectedProductionId}
              setSelectedId={setSelectedProductionId}
              placeholder="Select Production"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>
          {/* Quality */}
          <Col lg={6} xl={3}>
            <ColourDropDownFIlter
              label="Machine Group"
              data={machineGroupList}
              selectedValue={selectedMachineGroup}
              setSelectedValue={setSelectedMachineGroup}
              selectedId={selectedMachineGroupId}
              setSelectedId={setSelectedMachineGroupId}
              placeholder="Select Machine Group"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* Submit */}
          <Col lg={6} xl={3}>
            <button
              onClick={handlesubmit}
              style={{
                padding: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour7
                    : iscolourDark?.Colour7,
                color: "#fff",
                width: "100%",
                borderRadius: "12px",
                fontWeight: "700",
                height: "45px",
                border: "none",
              }}
            >
              Apply Filters
            </button>
          </Col>
        </Row>
      </div>
      <div
        style={{
          marginTop: "20px",
          borderRadius: "14px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          MACHINE GROUP BATCH COSTING
        </div>

        <ColourTable columns={TableChartColumns} data={TableChartRow} />
      </div>
      {/* 🔷 DATE PICKER MODAL */}
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <ColorCalenderCss
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour7
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
